/* tslint:disable:jsx-no-lambda*/
import { Button, PagingControl } from '@abb/common-ux';
import { Search } from '@module/shared';
import { IPagingSettings, ISortingSettings } from '@module/shared/components/Site/models';
import { SITE_LIST_SEARCH_PLACEHOLDER } from '@service/constants';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as ActionCreators from '../actionCreators/siteActionCreators';
import Sites from './Sites';

export class SitesContainer extends React.Component<any, any> {
  public render() {
    this.props.history.listen((location: any, action: any) => {
      if (action === 'PUSH' && location.pathname === '/') {
        this.props.clearSearchField();
     }
    });
    const searchServIsButton = <Button buttonType='primary' buttonSize='default' onClick={() => { this.handleServIsButtonClick(); }}>Search ServIS</Button>;
    return (
      <div className='container'>
        <div>
          <h3>Registered Sites</h3>
        </div>
        <div className='row'>
          <div className='col-sm-4'>
            <Search filter={this.props.searchFilter} applyFilter={this.props.applyFilter} clearFilter={this.props.clearFilter} changeFilterField={this.props.changeFilterField} placeholder={SITE_LIST_SEARCH_PLACEHOLDER}/>
          </div>
          <div className='col-sm-6 col-sm-offset-2 text-right'>
            {searchServIsButton}
            <PagingControl totalItemCount={this.props.totalNumberOfSites} top={this.props.pagingSettings.pageSize} skip={this.props.pagingSettings.skipItems} pageRequested={this.props.requestPage} />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <Sites sites={this.props.sites} sortingSettings={this.props.sortingSettings} history={this.props.history} sortField={this.props.sortField} searchFilter={this.props.searchFilter} sitesLoading={this.props.sitesLoading} />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.props.requestSitesGet(this.props.pagingSettings, this.props.sortingSettings, this.props.searchFilter, this.props.fromServIs);
  }

  handleServIsButtonClick() {
    this.props.history.push(`/register`);
    this.props.requestServIsPage(0);
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(SitesContainer) as any);

export function mapStateToProps(store: { sitesState: any; userState: { loggedInUser: { access_token: string } }; permissionsState: any }) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.sitesState, ...store.userState, ...store.permissionsState, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchPagingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchServIsPagingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onServIsPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchSortingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchApplyFilter: (searchFilter: string, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken)),
    dispatchFilterFieldChange: (searchFilter: string) =>
      dispatch(ActionCreators.onFilterFieldChange(searchFilter))
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, propsFromDispatch: any, ownProps: any) {
  return {
    ...propsFromState,
    ...ownProps,
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean) =>
      propsFromDispatch.requestSitesGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken),
    requestPage: (skipItems: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems };
      propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    requestServIsPage: (skipItems: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems };
      propsFromDispatch.dispatchServIsPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, true, accessToken);
    },
    sortField: (sortField: string) => {
      let newSortingSettings = null;
      if (sortField === propsFromState.sortingSettings.sortField) {
        const newDirection = propsFromState.sortingSettings.sortDirection === 'asc' ? 'desc' : 'asc';
        newSortingSettings = { ...propsFromState.sortingSettings, sortDirection: newDirection };
      } else {
        newSortingSettings = { sortField, sortDirection: 'asc' };
      }
      propsFromDispatch.dispatchSortingChange(propsFromState.pagingSettings, newSortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    applyFilter: (event: any) => {
      event.preventDefault();
      propsFromDispatch.dispatchApplyFilter(propsFromState.searchFilter, propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    clearFilter: () => { propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken); },
    changeFilterField: (event: React.ChangeEvent<any>) => {
      propsFromDispatch.dispatchFilterFieldChange(event.target.value);
    },
    clearSearchField: () => {
      propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    setPermissions: propsFromDispatch.setPermissions
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/site/components/SitesContainer.tsx